/** Customer example CSV (preview + download content). */
export const ROUTES_IMPORT_EXAMPLES_PATH = '/samples/routes-import-examples.csv';
export const ROUTES_IMPORT_EXAMPLES_FILENAME = 'routes-import-examples.csv';
/** Filename used when user downloads template from the modal. */
export const ROUTES_IMPORT_TEMPLATE_FILENAME = 'routes-import-template.csv';
